import React from "react";

/**
 * <p> tag
 */
interface MightierPProps extends React.HTMLProps<HTMLParagraphElement> {}

const MightierP = React.memo<MightierPProps>((props) => {
  const className = "text-base font-medium";
  const allClassNames = `${className} ${props?.className ?? ""}`;

  const { children, ...rest } = props;
  return (
    <p {...rest} className={allClassNames}>
      {children}
    </p>
  );
});

MightierP.displayName = "MightierP";

/**
 * <b> tag replacement (uses p under the hood for styling)
 */
interface MightierBProps extends React.HTMLProps<HTMLParagraphElement> {}

const MightierB = React.memo<MightierBProps>((props) => {
  const className = "text-base font-bold";
  const allClassNames = `${className} ${props?.className ?? ""}`;

  const { children, ...rest } = props;
  return (
    <p {...rest} className={allClassNames}>
      {children}
    </p>
  );
});

MightierB.displayName = "MightierB";

/**
 * <h1> tag
 */
interface MightierH1Props extends React.HTMLProps<HTMLParagraphElement> {}

const MightierH1 = React.memo<MightierH1Props>((props) => {
  const className = "text-[40px] font-bold text-black";
  const allClassNames = `${className} ${props?.className ?? ""}`;

  const { children, ...rest } = props;
  return (
    <h1 {...rest} className={allClassNames}>
      {children}
    </h1>
  );
});

MightierH1.displayName = "MightierH1";

/**
 * <h2> tag
 */
interface MightierH3Props extends React.HTMLProps<HTMLParagraphElement> {}

const MightierH3 = React.memo<MightierH3Props>((props) => {
  const className = "text-[20px] font-bold text-black";
  const allClassNames = `${className} ${props?.className ?? ""}`;

  const { children, ...rest } = props;
  return (
    <h1 {...rest} className={allClassNames}>
      {children}
    </h1>
  );
});

MightierH3.displayName = "MightierH3";

/**
 * <b> tag
 */
interface MightierMutedTextProps extends React.HTMLProps<HTMLParagraphElement> {}

const MightierMutedText = React.memo<MightierMutedTextProps>((props) => {
  const className = "text-xs text-black";
  const allClassNames = `${className} ${props?.className ?? ""}`;

  const { children, ...rest } = props;
  return (
    <h1 {...rest} className={allClassNames}>
      {children}
    </h1>
  );
});

MightierMutedText.displayName = "MightierMutedText";

/**
 *
 */
interface TypographyProps extends React.HTMLProps<HTMLParagraphElement> {
  variant?: "p" | "sm" | "b" | "h1" | "h3" | "muted";
  // allow passing extra tailwind classes
  extraClassName?: string;
}

export const Typography = React.memo<TypographyProps>((props) => {
  const { variant = "p" } = props;
  if (variant === "p") {
    return <MightierP {...props} />;
  }

  if (variant === "sm") {
    return <MightierP {...props} className={`text-sm ${props.className ?? ""}`} />;
  }

  if (variant === "b") {
    return <MightierB {...props} />;
  }

  if (variant === "h1") {
    return <MightierH1 {...props} />;
  }

  if (variant === "h3") {
    return <MightierH3 {...props} />;
  }

  if (variant === "muted") {
    return <MightierMutedText {...props} />;
  }

  return null;
});

Typography.displayName = "Typography";
